import { adminVerificationQueryKeys as e } from "./adminVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/admin/useReviewBusinessMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ workspaceId: e, payload: t }) => r.reviewBusinessVerification(e, t),
		onSuccess: (t, { workspaceId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail("business", n) });
		}
	});
};
//#endregion
export { i as useReviewBusinessMutation };
